import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { Button, Checkbox, Chip, FormControlLabel, FormGroup, Grid, makeStyles, TextField, Tooltip } from "@material-ui/core"
import SaveSearch from "../../common/dialog/SaveSearch"
import { useTranslation } from "react-i18next"
import { setNotification } from "../../../actions/notificationActions"
import { Edit as EditIcon, DeleteOutline as DeleteIcon } from "@material-ui/icons"
import { ReviewDetails } from "../../Reviews"
import { resetSelectedIdsAction } from "../../../actions/downloadsActions"

const useStyles = makeStyles((theme) => ({
	savedSearchName: {
		display: "inline-block",
		color: "#2C3533",
		fontSize: 16,
		marginBottom: 6,
	},
	searchInput: {
		width: "70%",
		border: `1px solid rgba(44, 53, 51, 0.12)`,
		borderRadius: "3px",
		background: "#ffffff",
		color: "#656363",
		//marginBottom: "11px",

		"& .MuiInputBase-root": {
			width: "100%",
			height: "45px",
			boxShadow: "none",
		},
		"& .MuiInputBase-input": {
			boxShadow: "none",
			border: "none",
		},
		"& .MuiInputBase-input:focus": {
			boxShadow: "none",
			border: "none",
		},
	},
	clearAll: {
		height: "45px",
		textTransform: "capitalize",
		fontWeight: 500,
		fontSize: "16px",
		marginLeft: "15px",
	},
	saveOption: {
		height: "45px",
		textTransform: "capitalize",
		fontWeight: 500,
		fontSize: "16px",
		marginLeft: "15px",
		color: "#3476E4",
	},
	searchButton: {
		width: "87px",
		height: "45px",
		background: "#3476E4",
		border: "1px solid rgba(44, 53, 51, 0.12)",
		borderRadius: "0px 3px 3px 0px",
		color: "#ffffff",
		textTransform: "capitalize",
		fontWeight: 500,
		fontSize: "16px",
		"&:hover": {
			backgroundColor: "rgb(21, 101, 192)",
			boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px",
		},
	},
	saveButton: {
		width: "57px",
		height: "37px",
		padding: "4px 12px",
		borderRadius: "3px",
	},
	searchName: {
		//width: "90%",
		padding: "30px 24px",
	},
	shareSearchWrapper: {
		margin: "0 0 20px 30px",
	},
	footerWrapper: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		padding: "17px 10px 0 0",
	},
	chipsElement: {
		margin: "0 8px 11px 0",
	},
	reviewButtons: {
		textTransform: "capitalize",
		marginLeft: 5,
	},
	searchSection: {
		display: "flex",
		flexGrow: 1,
		whiteSpace: "nowrap",
	},
	reviewSection: {
		display: "flex",
	},
}))

const SearchSection = ({
	selectedSearch,
	tempInputSearch,
	selectedYourConceptsDropdown,
	selectedSharedConceptsDropdown,
	setTempInputSearch,
	handleSearchCall,
	clearAllButtonClick,
	handleSaveSearch,
	setSelectedSharedConceptsDropdown,
	setSelectedYourConceptsDropdown,
	setCurrentConcept,
	setSelectedSearch,
	setSelectedYourSearchDropdown,
	setSelectedSharedSearchDropdown,
	selectedYourSearchDropdown,
	selectedSharedSearchDropdown,
	handleEditReview = () => {},
}) => {
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const location = useLocation()
	const classes = useStyles()
	const [saveModalOpen, setSaveModalOpen] = useState(false)
	const [modalTitle, setModalTitle] = useState("Save")
	const [name, setName] = useState("")
	const [shared, setShared] = useState(false)
	const [isInvalidToSave, setIsInvalidToSave] = useState(true)
	const [disableSave, setDisableSave] = useState(false)

	const conceptList = useSelector((state) => state?.buildconcept?.user_saved_build_concepts)
	const isSaving = useSelector((state) => state?.savedSearch?.isSaving)
	const isSaved = useSelector((state) => state?.savedSearch?.isSaved)
	const savedSearch = useSelector((state) => state?.savedSearch?.selectedSearch)
	const user = useSelector((state) => state?.authtentication?.user?.user)
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const selectedReview = useSelector((state) => state.review?.review)
	const is_case_admin = useSelector((state) => state.review?.is_case_admin)

	useEffect(() => {
		if (isSaved) {
			setSaveModalOpen(false)
			if (savedSearch?.shared) {
				setSelectedSharedSearchDropdown((prev) => savedSearch?.id)
			} else {
				setSelectedYourSearchDropdown((prev) => savedSearch?.id)
			}
			setSelectedSearch(savedSearch)
		}
	}, [isSaved])

	useEffect(() => {
		if (
			!tempInputSearch === null ||
			tempInputSearch?.trim() !== "" ||
			(selectedYourConceptsDropdown && selectedYourConceptsDropdown.length !== 0) ||
			(selectedSharedConceptsDropdown && selectedSharedConceptsDropdown.length !== 0)
		) {
			setIsInvalidToSave((prev) => false)
		} else {
			setIsInvalidToSave((prev) => true)
		}
		const disable_Save = selectedSearch ? selectedSearch?.shared === 1 && selectedSearch?.owner_id !== user?.userid : false
		setDisableSave((prev) => disable_Save)
	}, [tempInputSearch, selectedYourConceptsDropdown, selectedSharedConceptsDropdown])

	const saveModalOpenCall = (title) => {
		if (title === "save") {
			setModalTitle("Save")
			setName(selectedSearch?.name)
			setShared(selectedSearch?.shared)
		} else {
			setModalTitle("Save As")
			const saveAsName = selectedSearch?.name ? `${selectedSearch?.name}-1` : ""
			setName(saveAsName)
			setShared(false)
		}
		setSaveModalOpen(true)
	}

	const saveSearch = (e) => {
		dispatch(resetSelectedIdsAction())
		e.preventDefault()
		if (!name || name?.replace(/\s/g, "")?.length <= 0) {
			dispatch(
				setNotification({
					data: t("genericMsgs.noSaveNameEntered"),
					severity: "error",
				})
			)
			return
		}
		const payload = {
			name,
			shared: !!shared,
		}
		const isSaveAs = modalTitle === "Save As"
		handleSaveSearch(payload, isSaveAs)
	}

	const updateSearch = (event) => {
		dispatch(resetSelectedIdsAction())
		setTempInputSearch(event.target.value)
	}

	const handleEnterKeyPressed = (event) => {
		dispatch(resetSelectedIdsAction())
		if (event?.keyCode === 13 && location?.pathname?.includes("view-documents")) {
			handleSearchCall()
		}
	}

	const handleDelete = (concept) => {
		dispatch(resetSelectedIdsAction())
		if (concept?.shared === 0) {
			const filteredData = selectedYourConceptsDropdown?.filter((item) => item !== concept?.id) || []
			setSelectedYourConceptsDropdown((prevData) => [...filteredData])
			setCurrentConcept((prevData) => [...filteredData, ...(selectedSharedConceptsDropdown || [])])
		} else {
			const filteredData = selectedSharedConceptsDropdown?.filter((item) => item !== concept?.id) || []
			setSelectedSharedConceptsDropdown((prevData) => [...filteredData])
			setCurrentConcept((prevData) => [...filteredData, ...(selectedYourConceptsDropdown || [])])
		}
	}

	const toDisableClearAll = () =>
		tempInputSearch?.length <= 0 &&
		selectedYourConceptsDropdown?.length <= 0 &&
		selectedSharedConceptsDropdown?.length <= 0 &&
		selectedYourSearchDropdown?.length <= 0 &&
		selectedSharedSearchDropdown?.length <= 0

	return (
		<>
			<Grid container style={{ direction: "column", direction: "column", marginBottom: "29px" }}>
				<ReviewDetails selectedReview={selectedReview} />
				<section>
					<span className={classes.savedSearchName}>{selectedSearch?.name}</span>
				</section>
				<Grid container alignItems="center" justifyContent="space-between">
					<div className={classes.searchSection}>
						<TextField
							id="outlined-basic"
							className={classes.searchInput}
							variant="outlined"
							placeholder="Search for anything to start exploring the dataset"
							value={tempInputSearch}
							onChange={updateSearch}
							disabled={isReviewFormOpen}
							onKeyDown={handleEnterKeyPressed}
						/>
						<Button
							variant="outlined"
							size="small"
							className={classes.searchButton}
							onClick={() => {
								dispatch(resetSelectedIdsAction())
								handleSearchCall()
							}}
							disabled={isReviewFormOpen}
						>
							{t("search.search")}
						</Button>
						<Button
							variant="text"
							disabled={toDisableClearAll() || isReviewFormOpen}
							size="small"
							className={classes.clearAll}
							onClick={() => {
								dispatch(resetSelectedIdsAction())
								clearAllButtonClick()
							}}
						>
							{t("search.clear")}
						</Button>
						{/**If Review is selected then will not showing the save and saveAsbuttons */}
						{_.isEmpty(selectedReview) && (
							<>
								<Tooltip title={disableSave ? t("search.saveDisable") : ""} placement="top" arrow>
									<span>
										<Button
											variant="text"
											size="small"
											className={classes.saveOption}
											onClick={() => saveModalOpenCall("save")}
											disabled={isInvalidToSave || disableSave || isReviewFormOpen}
										>
											{t("search.save")}
										</Button>
									</span>
								</Tooltip>
								<Button
									variant="text"
									size="small"
									className={classes.saveOption}
									onClick={() => saveModalOpenCall("saveas")}
									disabled={isInvalidToSave || isReviewFormOpen}
								>
									{t("search.saveAs")}
								</Button>
							</>
						)}
					</div>

					{selectedReview?.id && user?.userid === selectedReview?.owner_id && is_case_admin && (
						<div className={classes.reviewSection}>
							<Button
								variant="contained"
								size="small"
								color="primary"
								className={classes.reviewButtons}
								onClick={() => handleEditReview(selectedReview?.id)}
								disabled={selectedReview?.user_assigned_method} // TODO : We need to undo this once we enable the Automatic Review Edit feature.
								startIcon={<EditIcon />}
							>
								{t("review.edit")}
							</Button>

							{/* <Button
								variant="outlined"
								size="small"
								className={classes.reviewButtons}
								//onClick={() => handleSearchCall()}
								//disabled={isReviewFormOpen}
								startIcon={<DeleteIcon />}
							>
								{t("review.delete")}
							</Button> */}
						</div>
					)}
				</Grid>
				<section style={{ marginTop: 11 }}>
					{conceptList?.length > 0 &&
						conceptList.map((dataList) => {
							let selectedConcept = [
								...(selectedYourConceptsDropdown?.length > 0 ? selectedYourConceptsDropdown : []),
								...(selectedSharedConceptsDropdown?.length > 0 ? selectedSharedConceptsDropdown : []),
							]?.filter((conceptItem) => conceptItem === dataList?.id)
							if (selectedConcept?.length) {
								return (
									<Chip
										label={dataList?.description}
										className={classes.chipsElement}
										onDelete={() => handleDelete(dataList)}
										disabled={isReviewFormOpen}
									/>
								)
							}
						})}
				</section>
			</Grid>
			<SaveSearch
				open={saveModalOpen}
				title={modalTitle}
				onClose={() => {
					setSaveModalOpen(false)
				}}
			>
				<TextField
					id="outlined-basic"
					className={classes.searchName}
					fullWidth
					variant="outlined"
					placeholder="Name"
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
				<FormGroup className={classes.shareSearchWrapper}>
					<FormControlLabel
						required
						control={<Checkbox onChange={(e) => setShared(e.target.checked)} checked={shared} />}
						label="Share search with others"
					/>
				</FormGroup>
				<Grid className={classes.footerWrapper}>
					<Button
						variant="outlined"
						size="small"
						className={classes.searchButton + " " + classes.saveButton}
						onClick={saveSearch}
						disabled={isSaving || name?.length === 0}
					>
						{t("search.save")}
					</Button>
					<Button variant="text" size="small" className={classes.clearAll} onClick={() => setSaveModalOpen(false)}>
						{t("search.cancel")}
					</Button>
				</Grid>
			</SaveSearch>
		</>
	)
}

export default SearchSection
